module.exports = __webpack_public_path__ + "static/img/173_TO8_1927.3ba3757.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/173_TO8_1927.jpg
// module id = iRrH
// module chunks = 0